import { Component, Input } from '@angular/core';

import { ComponentTypeEnum } from '~/attendee/enums/component.enum';
import { CmsSectionType } from '~/cms/interfaces/homepage.cms.interface';

@Component({
  selector: 'app-cms-section',
  templateUrl: './section.component.html',
})
export class CmsSectionComponent {
  @Input() public section: CmsSectionType;
  @Input() public isHp?: boolean;
  public readonly componentTypes = ComponentTypeEnum;
}
